enum TipoMovimientoDescripcion {
  Entrada = 'Entrada',
  Salida = 'Salida',
  Movimiento = 'Movimiento',
  Ajuste = 'Ajuste',
  Informativo = 'Informativo',
}

export default TipoMovimientoDescripcion;
